import React from 'react';
import axios from '../../api/axios';
import { IconCancelCircle } from '../../icons/icons';
import '../stylesheets/edit-personal-info.scss';



const EditPersonalInfo = (props) => {

  const [personalInfo, setPersonalInfo] = React.useState(
    {
      firstname: '',
      lastname: '',
      talent: '',
      location: '',
      availability: '',
      workTime: '',
      description: ''
    }
  );

  function personalInfoHandle({ target }) {
    setPersonalInfo({
      ...personalInfo,
      [target.name]: target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchURL = '/users';
    let id = localStorage.getItem('id');
    let formDataToPatch = { personalInfo };
    let axiosConfig = {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }

    await axios
      .patch(
        `${patchURL}/${id}`,
        formDataToPatch,
        axiosConfig
      )
      .then((response) => {
        let personalInfo = response.data.personalInfo;
        localStorage.setItem('personalInfo', JSON.stringify(personalInfo));
        props.updateHandle();
        props.personalInfoEditClose();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  if (!props.personalInfoState) {
    return null
  }
  return (
    <div className='modal-container-overlay'>
      <div className='personal-information-form-box'>
        <div className='personal-information-form-header'>
          <h3>Personal information</h3>
          <button onClick={props.personalInfoEditClose}>
            <i><IconCancelCircle /></i>
          </button>
        </div>
        <form
          className='personal-information-form'
          onSubmit={handleSubmit}
        >
          <div className='personal-information-content'>
            <div className='input-container'>
              <label htmlFor='firstname'>
                <h5>Firstname:</h5>
              </label>
              <input
                type='text'
                id='firstname'
                name='firstname'
                className='input-register'
                placeholder='Your firstname'
                required
                value={personalInfo.firstname}
                onChange={personalInfoHandle}
              />
            </div>
            <div className='input-container'>
              <label htmlFor='lastname'>
                <h5>Lastname:</h5>
              </label>
              <input
                type='text'
                id='lastname'
                name='lastname'
                className='input-register'
                placeholder='Your lastname'
                required
                value={personalInfo.lastname}
                onChange={personalInfoHandle}
              />
            </div>
            <div className='input-container'>
              <label htmlFor='talent'>
                <h5>Talent:</h5>
              </label>
              <input
                type='text'
                id='talent'
                name='talent'
                className='input-register'
                placeholder='Your profession or occupation'
                required
                value={personalInfo.talent}
                onChange={personalInfoHandle}
              />
            </div>
            <div className='input-container'>
              <label htmlFor='location'>
                <h5>Location:</h5>
              </label>
              <input
                type='text'
                id='location'
                name='location'
                className='input-register'
                placeholder='City, Country'
                required
                value={personalInfo.location}
                onChange={personalInfoHandle}
              />
            </div>
            <div className='input-container'>
              <label htmlFor='availability'>
                <h5>Availability:</h5>
              </label>
              <select
                type='text'
                id='availability'
                name='availability'
                className='input-register'
                required
                value={personalInfo.availability}
                onChange={personalInfoHandle}
              >
                <option value='' disabled defaultValue>Select your availability</option>
                <option value='on-line'>On-line</option>
                <option value='face-to-face'>Face-to-face</option>
                <option value='whatever-modality'>Any modality</option>
              </select>
            </div>
            <div className='input-container'>
              <label htmlFor='workTime'>
                <h5>Working hours:</h5>
              </label>
              <select
                type='text'
                id='working-time'
                name='workTime'
                className='input-register'
                required
                value={personalInfo.workTime}
                onChange={personalInfoHandle}
              >
                <option value='' disabled defaultValue>Select your working time</option>
                <option value='full-time'>Full time</option>
                <option value='middle-time'>Middle time</option>
                <option value='part-time'>Part time</option>
                <option value='any-time'>Any time</option>
              </select>
            </div>
            <div className='input-container'>
              <label htmlFor='description'>
                <h5>Personal description:</h5>
              </label>
              <textarea
                type='text'
                id='description'
                name='description'
                className='input-register'
                placeholder='I am very good..'
                required
                value={personalInfo.description}
                onChange={personalInfoHandle}
              />
            </div>
          </div>
          <div className='input-container-button'>
            <button type='submit'>
              <h4>Submit</h4>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditPersonalInfo;